<div class="phases" class="flex-center">
  <div
    *ngFor="let phase of productionSchedulePhases; let first = first"
    class="phase-container"
    [class.is-current]="isCurrentPhase(phase)"
    [class.is-active]="isActivePhase(phase)"
    (click)="phaseClicked(phase)"
  >
    <div [class.phases-track-inactive]="!isActivePhase(phase)" *ngIf="!first"></div>
    <div [class.phases-track-active]="isActivePhase(phase)" *ngIf="!first"></div>
    <mat-icon
      [svgIcon]="getIconForPhase(phase)"
      [class.icon-inactive]="!isActivePhase(phase)"
      [class.no-hover]="canHoverOverItem(phase)"
      [matTooltip]="getPhaseTranslationKey(phase) | bmsTranslate"
    ></mat-icon>
  </div>
</div>
